import { PrintItemElementsResponse } from "../../../models/api/sift/back/api-elements";
import { ApiBaseBack } from "../../back/api-base-back";

export class ApiGetElements extends ApiBaseBack<PrintItemElementsResponse> {
  constructor(param: {
    itemId: string,
  }) {
    super(
      'GET',
      '/api/v1/elements',
      'JSON',
      param,
    );
  }
}
